import { Layout } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useSEO } from '@/lib/useSEO';
import { FileText, RefreshCw } from 'lucide-react';
import { useFetch } from '@/components/dian/shared';
import { DianSummary } from '@/components/dian/DianSummary';
import { DianInvoicesPanel } from '@/components/dian/DianInvoicesPanel';
import { DianCreditNotesPanel } from '@/components/dian/DianCreditNotesPanel';
import { DianClosePanel } from '@/components/dian/DianClosePanel';
import { DianFactusPanel } from '@/components/dian/DianFactusPanel';
import { DianAuditPanel } from '@/components/dian/DianAuditPanel';

const TABS = [
  ['invoices', 'Facturas', DianInvoicesPanel],
  ['credit-notes', 'Notas crédito', DianCreditNotesPanel],
  ['close', 'Cierres mensuales', DianClosePanel],
  ['factus', 'Factus y rangos', DianFactusPanel],
  ['audit', 'Bitácora', DianAuditPanel],
];

export default function AdminDian() {
  useSEO({ title: 'Facturación DIAN · Admin' });
  const { data: health, loading, load } = useFetch('/admin/dian/health');
  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="admin-dian-page">
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-slate-500">Panel admin</div>
            <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900 mt-1 inline-flex items-center gap-2">
              <FileText className="h-6 w-6" /> Facturación DIAN
            </h1>
            <p className="text-sm text-slate-500 mt-1">Facturas, notas crédito, cierres de comisiones y estado de Factus.</p>
          </div>
          <Button data-testid="dian-reload-btn" onClick={load} variant="outline" className="rounded-none">
            <RefreshCw className={`mr-1 h-4 w-4 ${loading ? 'animate-spin' : ''}`} /> Recargar
          </Button>
        </div>
        <div className="mt-6"><DianSummary health={health} /></div>
        <Tabs defaultValue="invoices" className="mt-8">
          <TabsList className="rounded-none flex-wrap h-auto" data-testid="dian-tabs">
            {TABS.map(([k, label]) => (
              <TabsTrigger key={k} value={k} className="rounded-none" data-testid={`dian-tab-${k}`}>{label}</TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([k, , Panel]) => (
            <TabsContent key={k} value={k} className="mt-4"><Panel onChanged={load} /></TabsContent>
          ))}
        </Tabs>
      </div>
    </Layout>
  );
}
